import React from 'react'
import Contact from '../components/main/Contact'

function ContactPage() {
  return (
    <Contact/>
  )
}

export default ContactPage
